import { z } from 'zod';
import { i18n } from '../../../locales';
import { ReplyDeletePeriod } from '../../../types';

export const MAX_CONTENT_LENGTH = 3000;

export const createReplyFormSchema = z.object({
	content: z.string()
		.min(3, i18n.t('questions.form.content.minLength'))
		.max(
			MAX_CONTENT_LENGTH,
			i18n.t('questions.form.content.maxLength', { maxLength: MAX_CONTENT_LENGTH }),
		),
	deletePeriod: z.nativeEnum(ReplyDeletePeriod),
});

export type CreateReplyFormInput = z.infer<typeof createReplyFormSchema>;

export const createReplyFormInitialValues: CreateReplyFormInput = {
	content: '',
	deletePeriod: ReplyDeletePeriod.Never,
};
